module.exports = __webpack_public_path__ + "static/media/Olympics.92a84ec9.jpg";